import { useTranslation } from 'react-i18next'
import { Button, Image, Menu, Modal } from 'antd'
// import { useModalState } from '../../hooks/useModalState'
import ModalMaterial from './ModalMaterial'
import { useState } from 'react'
import ActionButton from '../common/button/ActionButton'

export const MaterialButton = ({ onClick, title, icon = false }) => {
  const { t } = useTranslation()
  return (
    <Button
      type='primary'
      icon={icon ? (
        <svg className='mr-2' width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M15.5819 12.0019C15.5819 12.7099 15.3719 13.4021 14.9785 13.9908C14.5852 14.5795 14.026 15.0384 13.3719 15.3094C12.7177 15.5803 11.9979 15.6512 11.3035 15.5131C10.609 15.375 9.97111 15.034 9.47043 14.5333C8.96976 14.0326 8.6288 13.3948 8.49067 12.7003C8.35253 12.0058 8.42343 11.286 8.69439 10.6319C8.96535 9.97771 9.42421 9.41859 10.0129 9.02522C10.6017 8.63184 11.2938 8.42188 12.0019 8.42188C12.4722 8.42135 12.9379 8.51359 13.3725 8.69332C13.8071 8.87304 14.202 9.13672 14.5345 9.46926C14.867 9.8018 15.1307 10.1967 15.3104 10.6312C15.4902 11.0658 15.5824 11.5316 15.5819 12.0019V12.0019Z'
            stroke='white' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
          <path
            d='M11.9998 20.2687C15.5298 20.2687 18.8198 18.1887 21.1098 14.5887C21.5524 13.7955 21.7847 12.9022 21.7847 11.9937C21.7847 11.0853 21.5524 10.192 21.1098 9.39875C18.8148 5.79875 15.5298 3.71875 11.9998 3.71875C8.46979 3.71875 5.1798 5.79875 2.8898 9.39875C2.44719 10.192 2.21484 11.0853 2.21484 11.9937C2.21484 12.9022 2.44719 13.7955 2.8898 14.5887C5.1798 18.1887 8.46979 20.2687 11.9998 20.2687Z'
            stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </svg>

      ) : ''}
      onClick={e => {
        e.stopPropagation()
        onClick && onClick()
      }}
    >
      {title ?? t('page.class.label.view_material')}
    </Button>
  )
}

export const MaterialModal = ({ visible, onClose, folderId }) => {
  const { t } = useTranslation()
  return (
    <Modal
      footer={null}
      visible={visible}
      onCancel={onClose}
      title={
        <span style={{ fontSize: '25px' }}>
          {t('page.class.label.detail_material')}
        </span>
      }
      destroyOnClose
      width={1300}
    >
      <ModalMaterial folderId={folderId} />
    </Modal>
  )
}

const Material = ({ folderId = null }) => {
  const { t } = useTranslation()
  const [isModalVisibleState, setIsModalVisibleState] = useState(false)
  const menu = (
    <Menu>
      <Menu.Item
        onClick={() => setIsModalVisibleState(true)}
        icon={
          <Image
            preview={false}
            src='/image/ui-kit/view-detail-icon.png'
            style={{ width: '24px', height: '24px' }}
          />
        }
      >
        {t('page.class.label.view_material')}
      </Menu.Item>
    </Menu>
  )
  return (
    <>
      <ActionButton menu={menu} />
      <MaterialModal
        visible={isModalVisibleState}
        onClose={() => setIsModalVisibleState(false)}
        folderId={folderId}
      />
    </>
  )
}
export default Material
